import { z } from "zod";

export const COSHHChemicalSchema = z.object({
  chemicalRegisterEntryId: z.object({ label: z.string(), value: z.string() }),
  routeOfExposure: z.string().min(1, "Route of exposure is required"),
  quantityUsed: z.string().min(1, "Quantity used is required"),
  frequencyOfUse: z.string().min(1, "Frequency of use is required"),
  initialRiskLevelId: z
    .object({ label: z.string(), value: z.string() })
    .optional(),
  residualRiskLevelId: z
    .object({ label: z.string(), value: z.string() })
    .optional(),
});

export const CreateCOSHHSchema = z.object({
  reference: z.string().min(1, "Reference is required"),
  title: z.string().min(1, "Title is required"),
  description: z.string().min(1, "Description is required"),
  siteId: z.object({ label: z.string(), value: z.string() }).optional(),
  evaluatorId: z.object({ label: z.string(), value: z.string() }).optional(),
  assessmentDate: z.date(),
  nextReviewDate: z.date().optional(),
  chemicals: z
    .array(COSHHChemicalSchema)
    .min(1, "At least one chemical must be added"),
});

export type TCreateCOSHH = z.infer<typeof CreateCOSHHSchema>;
export type TCOSHHChemical = z.infer<typeof COSHHChemicalSchema>;
